import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "water",
  "use": "water-usage",
  "viewBox": "0 0 14.14 20",
  "content": "<symbol viewBox=\"0 0 14.14 20\" id=\"water\"><path d=\"M8.24 4.22c1.81 2.26 3.9 5.63 3.9 8.45A5.09 5.09 0 0 1 7.07 18c-.05 0-5-.13-5.07-4.85 0-1.57 1.61-3.35 3.21-5.07a20 20 0 0 0 3-3.86M6.82 0v.11C8.63 4.44-.12 8.19 0 13.19.13 18.43 4.71 20 7.07 20a7.1 7.1 0 0 0 7.07-7.33C14.14 6.8 7.35 0 6.82 0z\" opacity=\".9\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/water.svg
// module id = 7O0Z
// module chunks = 1